export const bulletTypeToBlockName = {
    bullet: "bullet",
    circle: "circle",
    square: "square",
};

export const numberTypeList = {
    number: "number",
    smallAlpha: "smallAlpha",
    capitalAlpha: "capitalAlpha",
    smallRoman: "smallRoman",
    capitalRoman: "capitalRoman",
    lowerGreek: "lowerGreek",
};